import React from "react";
import { Link, useParams } from "react-router-dom";
import guLocale from "../locales/gu";
import { useAuth } from '../context/AuthContext';

const ErrorPage = () => {
  const { errorCode } = useParams(); // Get error code from URL
  const locale = guLocale.errorPages[errorCode] || guLocale.errorPages[404]; // Default to 404
  const { isAdminUser } = useAuth();

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "20px"
    }}>
      <h1 style={{ fontSize: "6rem", color: "#DC3545", marginBottom: "10px" }}>
        {locale.headline}
      </h1>
      <h3 style={{ fontSize: "1.8rem", color: "#333", marginBottom: "15px" }}>
        <i className="fas fa-exclamation-triangle text-danger" /> {locale.title}
      </h3>
      <p style={{ fontSize: "1.2rem", color: "#555" }}>
        {locale.description}  
        <Link to={ isAdminUser ? '/admin/dashboard' : '/dashboard' } style={{ color: "#007BFF", textDecoration: "none", marginLeft: "5px" }}>
          {locale.returnToDashboard}
        </Link>
      </p>
    </div>
  );
};

export default ErrorPage;